import React from 'react';
import { Link } from 'react-router-dom';

function Success() {
  return (
    <div className="thank-you-message">
      <h3>Profile Setup Complete!</h3>
      <p>Your player profile has been successfully created.</p>
      <p>An admin will review your details and approve your registration. Once approved, you will be able to log in to your account.</p>
      <Link to="/" className="login-link">
        Return to Login
      </Link>
    </div>
  );
}

export default Success; 